'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _underscore = require('../utils/underscore');

var _devLogger = require('react-utils/devLogger');

var _devLogger2 = _interopRequireDefault(_devLogger);

var _reactAddonsCssTransitionGroup = require('react-addons-css-transition-group');

var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _ActiveElement = require('../core/ActiveElement');

var _Selectors = require('../constants/Selectors');

var _UIDialog = require('./UIDialog');

var _UIDialog2 = _interopRequireDefault(_UIDialog);

var _UIDialogCloseButton = require('./UIDialogCloseButton');

var _UIDialogCloseButton2 = _interopRequireDefault(_UIDialogCloseButton);

var _UIOverlay = require('../overlay/UIOverlay');

var _UIOverlay2 = _interopRequireDefault(_UIOverlay);

var _FirstChild = require('../utils/FirstChild');

var _FirstChild2 = _interopRequireDefault(_FirstChild);

var _Functions = require('../core/Functions');

var _Dom = require('../utils/Dom');

var _DialogConstants = require('./DialogConstants');

var _ModalDialogTransitions = require('./ModalDialogTransitions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

exports.default = _react2.default.createClass({
  displayName: 'UIModalDialog',

  propTypes: {
    centered: _react.PropTypes.bool.isRequired,
    children: _react.PropTypes.node,
    className: _react.PropTypes.string,
    contextual: _react.PropTypes.bool,
    _dialogWidth: _react.PropTypes.number,
    dialogClassName: _react.PropTypes.string,
    onClick: _react.PropTypes.func,
    onCloseComplete: _react.PropTypes.func,
    onCloseStart: _react.PropTypes.func,
    onEsc: _react.PropTypes.func,
    onOpenComplete: _react.PropTypes.func,
    onOpenStart: _react.PropTypes.func,
    onOverlayClick: _react.PropTypes.func,
    role: _react.PropTypes.string,
    size: _react.PropTypes.oneOf(Object.keys(_DialogConstants.SIZE_CLASSES)),
    style: _react.PropTypes.object,
    use: _react.PropTypes.oneOf(Object.keys(_DialogConstants.USE_CLASSES)),
    _use: _react.PropTypes.oneOf(['sidebar']),
    width: _react.PropTypes.number.isRequired
  },

  contextTypes: {
    sandboxed: _react.PropTypes.bool
  },

  getDefaultProps: function getDefaultProps() {
    return {
      centered: false,
      contextual: false,
      role: 'dialog',
      use: 'default',
      size: 'auto',
      width: 450
    };
  },
  getInitialState: function getInitialState() {
    // To control animations with CSSTransitionGroup, we need to switch between
    // rendering a child component and rendering null.
    return {
      openComplete: false,
      dialogShouldRender: true,
      overlayShouldRender: true
    };
  },
  componentDidMount: function componentDidMount() {
    var _props = this.props,
        contextual = _props.contextual,
        use = _props.use;

    this._isMounted = true;

    if (!contextual) {
      this.listenForLayerUnmount();
      this.listenForFocusCycle();
      this.announceOpen();
    }

    if (use === 'sidebar') {
      _devLogger2.default.warn({
        message: 'UIModal: The sidebar use prop is deprecated, please use' + ' the `UIModalPanel` component instead.',
        key: 'UIModal: use sidebar error'
      });
    }
  },
  componentWillUnmount: function componentWillUnmount() {
    this._isMounted = false;
    clearTimeout(this._openTimeout);
    clearTimeout(this._closeTimeout);
    this.unlistenForLayerUnmount();
    this.unlistenForFocusCycle();
  },
  isSandboxed: function isSandboxed() {
    return this.props.contextual || this.context.sandboxed;
  },
  getModalDOMNode: function getModalDOMNode() {
    if (!this._isMounted) {
      return null;
    }
    return (0, _reactDom.findDOMNode)(this);
  },
  getComputedUse: function getComputedUse(use, _use) {
    return _use || use;
  },
  listenForLayerUnmount: function listenForLayerUnmount() {
    var el = this.getModalDOMNode();
    while (el && el.className !== 'private-layer') {
      el = el.parentElement;
    }
    if (el) {
      this._layerEl = el;
      this._layerEl.addEventListener('uilayer-willunmount', this.startClose);
    }
  },
  unlistenForLayerUnmount: function unlistenForLayerUnmount() {
    if (this._layerEl) {
      this._layerEl.removeEventListener('uilayer-willunmount', this.startClose);
    }
  },
  listenForFocusCycle: function listenForFocusCycle() {
    // Disable the mutation observer during blur, as the value of
    // document.activeElement in that phase is misleading.
    window.addEventListener('blur', this.handleWindowBlur, { capture: true });
    window.addEventListener('focus', this.handleWindowFocus, { capture: true });
  },
  unlistenForFocusCycle: function unlistenForFocusCycle() {
    window.removeEventListener('blur', this.handleWindowBlur, {
      capture: true
    });
    window.removeEventListener('focus', this.handleWindowFocus, {
      capture: true
    });
  },
  startClose: function startClose() {
    var _this = this;

    if (!this._isMounted) {
      return;
    }

    // Removing the overlay from the render tree also removes the dialog, so
    // we need to remove the dialog first to trigger its "leave" transition...
    this.setState({
      dialogShouldRender: false
    });
    // Then we remove the overlay on the next tick, triggering its (separate)
    // "leave" transition.
    setTimeout(function () {
      _this.setState({
        overlayShouldRender: false
      });
    }, 10);
    this.announceClose();
  },
  announceOpen: function announceOpen() {
    var _this2 = this;

    var _props2 = this.props,
        onOpenComplete = _props2.onOpenComplete,
        onOpenStart = _props2.onOpenStart,
        use = _props2.use,
        _use = _props2._use;

    var computedUse = this.getComputedUse(use, _use);
    if (this.isSandboxed()) {
      return;
    }
    (0, _Functions.callIfPossible)(onOpenStart);
    this.dispatchDOMEvent('uimodaldialog-openstart');
    this._openTimeout = setTimeout(function () {
      _this2.setState({ openComplete: true });
      _this2.captureFocus();
      _this2.emulateAutofocus();
      (0, _Functions.callIfPossible)(onOpenComplete);
      _this2.dispatchDOMEvent('uimodaldialog-opencomplete');
      _this2.startMutationObserver();
    }, (0, _ModalDialogTransitions.getTransitionDuration)({ use: computedUse }));
  },
  announceClose: function announceClose() {
    var _this3 = this;

    this.stopMutationObserver();
    var _props3 = this.props,
        onCloseComplete = _props3.onCloseComplete,
        onCloseStart = _props3.onCloseStart,
        use = _props3.use,
        _use = _props3._use;

    var computedUse = this.getComputedUse(use, _use);
    if (this.isSandboxed()) {
      return;
    }
    this.setState({ openComplete: false });
    (0, _Functions.callIfPossible)(onCloseStart);
    this.dispatchDOMEvent('uimodaldialog-closestart');
    this._closeTimeout = setTimeout(function () {
      (0, _Functions.callIfPossible)(onCloseComplete);
      _this3.dispatchDOMEvent('uimodaldialog-closecomplete');
    }, (0, _ModalDialogTransitions.getTransitionDuration)({ use: computedUse }));
  },
  dispatchDOMEvent: function dispatchDOMEvent(eventName) {
    // Note that `new Event()` does not work in IE11! (HubSpot/UIComponents#222)
    var dialog = this.getModalDOMNode();
    if (!dialog) {
      return;
    }
    var event = document.createEvent('Event');
    event.initEvent(eventName, true, true);
    dialog.dispatchEvent(event);
  },
  startMutationObserver: function startMutationObserver() {
    if (this._observer) {
      return;
    }
    var dialog = this.getModalDOMNode();
    if (!dialog) {
      return;
    }
    var _window = window,
        MutationObserver = _window.MutationObserver;

    if (!MutationObserver) {
      return; // No browser support, bummer!
    }
    // The focus should always be inside of the modal. We may need to recapture
    // it after an update because the focused element may have been unmounted.
    this._observer = new MutationObserver(this.captureFocus);
    this._observer.observe(dialog, {
      attributes: true,
      childList: true,
      subtree: true
    });
  },
  stopMutationObserver: function stopMutationObserver() {
    if (this._observer) {
      this._observer.disconnect();
      this._observer = null;
    }
  },
  handleWindowBlur: function handleWindowBlur() {
    this.stopMutationObserver();
  },
  handleWindowFocus: function handleWindowFocus() {
    this.startMutationObserver();
  },
  captureFocus: function captureFocus() {
    // If the focus is currently within the page (or null/<body>), focus on this
    // dialog so that tabbing works. We *don't* want to capture focus if the
    // element is in a non-page element, e.g. a popover or other modal.
    var dialog = this.getModalDOMNode();
    if (!dialog) {
      return;
    }
    var activeElement = (0, _ActiveElement.getActiveElement)();
    var dialogContainsActiveElement = dialog.contains(activeElement);
    var shouldCapture = false;
    if (!activeElement || activeElement === document.body) {
      shouldCapture = true;
    } else if (!dialogContainsActiveElement) {
      // A few weird apps have multiple .page elements...
      var pages = document.querySelectorAll('body > .page');
      for (var i = 0; i < pages.length; i++) {
        if (pages[i].contains(activeElement)) {
          shouldCapture = true;
          break;
        }
      }
    }
    // Also, we also want to move focus to the dialog if the focus has somehow
    // wound up on a non-focusable element *within* the dialog.
    if (dialogContainsActiveElement && !(0, _Dom.matches)(activeElement, _Selectors.FOCUSABLE)) {
      shouldCapture = true;
    }
    if (shouldCapture) {
      dialog.focus();
    }
  },
  emulateAutofocus: function emulateAutofocus() {
    // The autofocus attribute is finicky, so we instead use our own
    // [data-modalfocus] selector to determine the initial focus.

    var dialog = this.getModalDOMNode();
    if (!dialog) {
      return;
    }
    var focusEl = dialog.querySelector('[data-modalfocus]');
    if (focusEl) {
      focusEl.focus();
    }
  },
  handleKeyDown: function handleKeyDown(evt) {
    // Based on https://www.w3.org/TR/wai-aria-practices/#trap_focus_div
    var activeElement = (0, _ActiveElement.getActiveElement)();
    var dialog = (0, _reactDom.findDOMNode)(this);
    var allFocusableElements = dialog.querySelectorAll(_Selectors.FOCUSABLE);
    var firstFocusableElement = (0, _underscore.first)(allFocusableElements);
    var lastFocusableElement = (0, _underscore.last)(allFocusableElements);
    if (evt.key === 'Tab') {
      if (evt.shiftKey) {
        // Shift+Tab: If focus is on first element, cycle to last element
        if (activeElement === firstFocusableElement || activeElement === dialog) {
          evt.preventDefault();
          lastFocusableElement.focus();
        }
      } else {
        // Unmodified Tab: If focus is on last element, cycle to first element
        if (activeElement === lastFocusableElement || activeElement === dialog) {
          evt.preventDefault();
          firstFocusableElement.focus();
        }
      }
    } else if (evt.key === 'Escape') {
      if (typeof this.props.onEsc === 'function') {
        this.props.onEsc(evt);
      } else {
        this.triggerCloseButton();
      }
    }
  },
  triggerCloseButton: function triggerCloseButton() {
    // If there's a close button but no onEsc handler, treat pressing Esc as
    // equivalent to clicking the close button.
    var dialog = (0, _reactDom.findDOMNode)(this);
    var closeButton = dialog.querySelector('[data-action=close]');
    if (closeButton) {
      closeButton.click();
    }
  },
  renderOverlay: function renderOverlay(_ref, _ref2) {
    var contextual = _ref.contextual,
        rest = _ref.rest;
    var closeButton = _ref2.closeButton,
        dialogTransitionProps = _ref2.dialogTransitionProps,
        renderedDialog = _ref2.renderedDialog,
        computedUse = _ref2.computedUse;
    var _state = this.state,
        openComplete = _state.openComplete,
        overlayShouldRender = _state.overlayShouldRender;

    var centerContent = ['fullscreen', 'sidebar'].indexOf(computedUse) === -1;
    return overlayShouldRender ? _react2.default.createElement(
      _UIOverlay2.default,
      _extends({}, rest, {
        centerContent: centerContent,
        contextual: contextual,
        'data-component-name': 'UIModalDialog',
        'data-open-complete': openComplete,
        onKeyDown: this.handleKeyDown,
        tabIndex: -1
      }),
      _react2.default.createElement(
        _reactAddonsCssTransitionGroup2.default,
        dialogTransitionProps,
        renderedDialog
      ),
      closeButton
    ) : null;
  },
  renderDialog: function renderDialog(_ref3, _ref4) {
    var centered = _ref3.centered,
        dialogClassName = _ref3.dialogClassName,
        _dialogWidth = _ref3._dialogWidth,
        role = _ref3.role,
        size = _ref3.size;
    var dialogChildren = _ref4.dialogChildren,
        computedUse = _ref4.computedUse;
    var dialogShouldRender = this.state.dialogShouldRender;

    return dialogShouldRender ? _react2.default.createElement(
      _UIDialog2.default,
      {
        _dialogWidth: _dialogWidth,
        centered: centered,
        className: dialogClassName,
        role: role,
        size: size,
        use: computedUse
      },
      dialogChildren
    ) : null;
  },
  render: function render() {
    var _props4 = this.props,
        centered = _props4.centered,
        children = _props4.children,
        contextual = _props4.contextual,
        dialogClassName = _props4.dialogClassName,
        _dialogWidth = _props4._dialogWidth,
        __onCloseComplete = _props4.onCloseComplete,
        __onCloseStart = _props4.onCloseStart,
        __onEsc = _props4.onEsc,
        __onOpenComplete = _props4.onOpenComplete,
        __onOpenStart = _props4.onOpenStart,
        role = _props4.role,
        size = _props4.size,
        use = _props4.use,
        _use = _props4._use,
        rest = _objectWithoutProperties(_props4, ['centered', 'children', 'contextual', 'dialogClassName', '_dialogWidth', 'onCloseComplete', 'onCloseStart', 'onEsc', 'onOpenComplete', 'onOpenStart', 'role', 'size', 'use', '_use']);

    var computedUse = this.getComputedUse(use, _use);

    var dialogTransitionProps = (0, _ModalDialogTransitions.getDialogTransitionProps)({
      contextual: this.isSandboxed(),
      use: computedUse
    });

    // If one of the children is <UIDialogCloseButton detached>, render it in
    // the overlay instead of the dialog.
    var closeButton = null;
    var dialogChildren = _react2.default.Children.map(children, function (child) {
      if (child === null) {
        return null;
      } else if (child.type === _UIDialogCloseButton2.default && child.props.detached) {
        closeButton = child;
        return null;
      }
      return child;
    });

    var renderedDialog = this.renderDialog({ centered: centered, dialogClassName: dialogClassName, _dialogWidth: _dialogWidth, role: role, size: size }, { dialogChildren: dialogChildren, computedUse: computedUse });

    return _react2.default.createElement(
      _reactAddonsCssTransitionGroup2.default,
      _extends({}, (0, _ModalDialogTransitions.getOverlayTransitionProps)({
        contextual: this.isSandboxed(),
        use: computedUse
      }), {
        component: _FirstChild2.default
      }),
      this.renderOverlay({ contextual: contextual, rest: rest }, { closeButton: closeButton, dialogTransitionProps: dialogTransitionProps, renderedDialog: renderedDialog, computedUse: computedUse })
    );
  }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1179/js/dialog/UIModalDialog.js
// module id = 322
// module chunks = 0